import { gql } from '@apollo/client'

export const UNASSIGNED_CASE_EMAILS_COUNT_QUERY = gql`
  query unassignedCaseEmailsCount {
    unassignedCaseEmailsCount
  }
`
